define('common/views/max_domains_popup',['require','exports','module','common/views/trial_expiration_popup','ldsh!../templates/max_domains_popup'],function(require, exports, module) {
  "use strict";

  var TrialExpirationPopUp = require("common/views/trial_expiration_popup");

  module.exports = TrialExpirationPopUp.extend({
    template: require("ldsh!../templates/max_domains_popup")
  }, {
    show: function() {
      var popup = new module.exports();
      return popup;
    }
  });

});

